<div *ngIf="message" [ngClass]="message.cssClass">
  <button class="btn btn-circle float-right" (click)="alertService.clear()"><fa-icon [icon]="faTimes"></fa-icon></button>
  <span class="message" [innerHTML]="message.text | translate"></span>
</div>
